import applyHeatmap from './heatmaps.ts'
import { getGameSituation } from '../game-situation.ts'

import getVal from '../utils/win-prob-value.ts'
import { WinProbabilityRow } from '../types/win-probabilty.ts'
import { GameSituation } from '../types/game-situation.ts'

export default function renderWinProbabilityByCountTable(
    data: WinProbabilityRow[]
) {
    if (!data.length) {
        console.warn('No leverage index data returned')
    }

    const gameSituation = getGameSituation()

    // Determine if we need to flip the columns
    const shouldFlip = false
    /* gameSituation.perspective === 'bat' &&
        ((gameSituation.half === 'Top' && gameSituation.run_diff < 0) ||
            (gameSituation.half === 'Bottom' && gameSituation.run_diff >= 0)) */

    // Set Dynamic Headers
    const leftHeader =
        gameSituation.perspective === 'bat'
            ? 'Batting Team Losing'
            : 'Visiting Team'
    const rightHeader =
        gameSituation.perspective === 'bat'
            ? 'Batting Team Winning'
            : 'Home Team'

    const footer = gameSituation.perspective === 'bat' ? 'Batting' : 'Home'

    const table = `
<table id="tbl-win-prob-count">
  <thead>
    <tr class="secondary-header">
      <th colspan="5"></th>
      <th colspan="5"  class="th-title-header">${leftHeader}</th>
      <th></th>
      <th colspan="5"  class="th-title-header">${rightHeader}</th>
    </tr>  
    <tr class="tr-component-row">
      <th class="th-component-header align-center">Inning</th>
      <th class="th-component-header align-center">Top/Bot</th>
      <th class="th-component-header align-center">Outs</th>
      <th class="th-component-header align-center">Runners</th>
      <th class="th-component-header align-center">Count</th>
      <th class="th-component-header align-center border-left" data-count="-5">+5</th>
      <th class="th-component-header align-center" data-count="-4">+4</th>
      <th class="th-component-header align-center" data-count="-3">+3</th>
      <th class="th-component-header align-center" data-count="-2">+2</th>
      <th class="th-component-header align-center" data-count="-1">+1</th>
      <th class="th-component-header align-center border-left" data-count="0">Tie</th>
      <th class="th-component-header align-center border-left" data-count="1">+1</th>
      <th class="th-component-header align-center" data-count="2">+2</th>
      <th class="th-component-header align-center" data-count="3">+3</th>
      <th class="th-component-header align-center" data-count="4">+4</th>
      <th class="th-component-header align-center border-right" data-count="5">+5</th>
    </tr>
  </thead>
  <tbody>
    ${data
        .map(
            (row) => `
      <tr class="default-table-row" data-count="${row.ball_count}-${
                row.strike_count
            }">
        <td class="tr-data align-center">${row.inning}</td>
        <td class="tr-data align-center">${row.bottom_top}</td>
        <td class="tr-data align-center">${row.outs}</td>
        <td class="tr-data align-center">${row.bases}</td>
        <td class="tr-data align-center">${row.ball_count}-${
                row.strike_count
            }</td>
        <td class="tr-data align-center border-left" data-situation="-5">${getVal(
            row,
            shouldFlip,
            -5
        )}</td>
        <td class="tr-data align-center" data-situation="-4">${getVal(
            row,
            shouldFlip,
            -4
        )}</td>
        <td class="tr-data align-center" data-situation="-3">${getVal(
            row,
            shouldFlip,
            -3
        )}</td>
        <td class="tr-data align-center" data-situation="-2">${getVal(
            row,
            shouldFlip,
            -2
        )}</td>
        <td class="tr-data align-center" data-situation="-1">${getVal(
            row,
            shouldFlip,
            -1
        )}</td>
        <td class="tr-data align-center border-left" data-situation="0">${getVal(
            row,
            shouldFlip,
            0
        )}</td>
        <td class="tr-data align-center border-left" data-situation="1">${getVal(
            row,
            shouldFlip,
            1
        )}</td>
        <td class="tr-data align-center" data-situation="2">${getVal(
            row,
            shouldFlip,
            2
        )}</td>
        <td class="tr-data align-center" data-situation="3">${getVal(
            row,
            shouldFlip,
            3
        )}</td>
        <td class="tr-data align-center" data-situation="4">${getVal(
            row,
            shouldFlip,
            4
        )}</td>
        <td class="tr-data align-center border-right" data-situation="5">${getVal(
            row,
            shouldFlip,
            5
        )}</td>
      </tr>`
        )
        .join('')}
    <tr>
    <td colspan="5"></td>
    <td colspan="11" class="footer-title">Probability ${footer} Team Wins</td>
    </tr>
  </tbody>
</table>
`
    const el = document.getElementById(
        'game-strategy-explorer-by-count-table-wrapper'
    )

    if (el) {
        el.innerHTML = table
    }
    applyHeatmap('tbl-win-prob-count')
    highlightMatchingRowByCount(gameSituation)
}
function highlightMatchingRowByCount(situation: Partial<GameSituation>) {
    // Clear previous highlights ONLY in the by-count table
    document
        .querySelectorAll(
            '#game-strategy-explorer-by-count-table-wrapper .cell-highlight'
        )
        .forEach((el) => el.classList.remove('cell-highlight'))

    if (situation.balls == null || situation.strikes == null) {
        return
    }

    const countKey = `${situation.balls}-${situation.strikes}`

    const rows = document.querySelectorAll<HTMLTableRowElement>(
        '#game-strategy-explorer-by-count-table-wrapper table tbody tr'
    )

    const shouldFlip = false
    /* situation.perspective === 'bat' &&
        situation.half === 'Bottom' &&
        situation.run_diff >= 0 */

    let runDiff = situation.run_diff ?? 0

    if (shouldFlip) {
        runDiff *= -1
    }

    rows.forEach((row) => {
        if (row.dataset.count !== countKey) return

        const cell = row.querySelector<HTMLElement>(
            `[data-situation="${runDiff}"]`
        )
        if (cell) {
            cell.classList.add('cell-highlight')
        }
    })
}
